import {
    PM_SESSION_START,
    PM_WINDOW_MAXIMIZE
} from '../constants/pm';

import {
    VIDEO_WINDOW_OPEN
} from '../constants/streaming';

import {
    ROOM_SWITCHED
} from '../constants/rooms';

const browserMiddleware = (store) => (next) => (action) => {
    if ([PM_SESSION_START, PM_WINDOW_MAXIMIZE, ROOM_SWITCHED, VIDEO_WINDOW_OPEN].indexOf(action.type) != -1) {
        let browser = store.getState().browser;

        next({...action, browser});
    } else {
        next(action);
    }
};

export default browserMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/browser.js